<template>
  <SoDialog v-model="value">
    <template #title> No forwarding address </template>
    <p class="mb-4">
      If the customer is unable or unwilling to provide a forwarding address,
      please probe for valid reasons why.
    </p>

    <p class="mb-4">
      It is important to get the correct forwarding address, so that any final
      communications can be sent to the customer and their final balance can be
      settled.
    </p>

    <p class="mb-4">
      As a last resort, we can set the current supply address but this should
      only be done if the customer genuinely doesn’t have a forwarding address.
    </p>
    <SoCheckbox
      v-model="currentSupplyAddress"
      :label="`Use current supply address`"
    />
    <SoTextarea
      v-if="currentSupplyAddress"
      v-model="reason"
      label="Reason customer is unable to provide forwarding address"
      class="mt-8"
    />
    <div class="d-flex justify-end mt-4 gap-2">
      <SoButton
        data-testid="flow-action-back"
        title="Back"
        large
        @click="value = false"
      />
      <SoButton
        data-testid="flow-action-back"
        title="Confirm"
        type="primary"
        large
        @click="confirmChanges"
      />
    </div>
  </SoDialog>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import { useCurrentAccountStore } from "@/stores/currentAccount"
  import SoDialog from "@/components/SoDialog.vue"
  import SoCheckbox from "@/components/formControls/SoCheckbox.vue"
  import SoTextarea from "@/components/formControls/SoTextarea.vue"
  import SoButton from "@/components/formControls/SoButton.vue"

  export default defineComponent({
    components: {
      SoButton,
      SoTextarea,
      SoCheckbox,
      SoDialog,
    },
    props: {
      modelValue: {
        type: Boolean,
        default: false,
        required: true,
      },
    },
    emits: ["update:modelValue", "onSupplyAddress"],
    data() {
      return {
        addNoteMutator: useCurrentAccountStore().addNote(),
        initialCurrentSupplyAddress: false,
        initialReason: "",
        currentSupplyAddress: false,
        reason: "",
      }
    },
    computed: {
      value: {
        get() {
          return this.modelValue
        },
        set(value: boolean) {
          if (!value) {
            this.initialCurrentSupplyAddress = this.currentSupplyAddress
            this.initialReason = this.reason
          }
          this.$emit("update:modelValue", value)
        },
      },
    },
    mounted() {
      this.currentSupplyAddress = this.initialCurrentSupplyAddress
      this.reason = this.initialReason
    },
    methods: {
      confirmChanges() {
        this.$emit("onSupplyAddress", {
          hasSupplyAddress: this.currentSupplyAddress,
          reason: this.reason,
        })
        if (this.currentSupplyAddress) {
          this.addNoteMutator.mutate({
            subject: "General Note",
            summary: "Customer cannot provide a Forwarding address",
            content: this.reason,
          })
        }
        this.value = false
      },
    },
  })
</script>
